import get from "lodash.get";

export const featuredImage = (resource, full) => {
    if (!full && resource.thumbnail) return resource.thumbnail;

    const image = get(resource, "_embedded.wp:featuredmedia");
    const embeddedImage = image && image.length ? image[0] : null;

    if (embeddedImage && (embeddedImage.source_url || embeddedImage.url)) {
        return embeddedImage;
    }

    return resource.thumbnail || null;
};

export const getImageAspect = (image, fallback = null) => {
    if (!image) return null;

    if (typeof image == "string") return fallback;

    const width = get(image, "media_details.width", get(image, "width"));
    const height = get(image, "media_details.height", get(image, "height"));

    if (!width || !height) return fallback;

    return width / height;
};
